import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ResourceRegModal from "../../../../modal/PC/gijun/ResourceRegModal";
import ResourceUpdateModal from "../../../../modal/PC/gijun/ResourceUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";

const Resource = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [typeOption, setTypeOption] = useState([]);
    const [typeModalOption, setTypeModalOption] = useState([]);
    const [produceYnOption, setProduceYnOption] = useState([]);
    const [statusOption, setStatusOption] = useState([]);
    const [statusModalOption, setStatusModalOption] = useState([]);
    const [priceCurrencyModalOption, setPriceCurrencyModalOption] = useState([]);
    const [userTypeModalOption, setUserTypeModalOption] = useState([]);
    const [workplaceModalOption, setWorkplaceModalOption] = useState([]);
    const [userModalOption, setUserModalOption] = useState([]);
    const [keyword, setKeyword] = useState({
        type:0,
        produce_yn:0,
        status:0,
        search:''
    });
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectResourceID, setSelectResourceID] = useState('');
    
    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'resource_id', width: 0, headerAlign: 'center' },
            { field: 'resource_id', headerName: 'resource_id', width: 0, headerAlign: 'center' },
            { field: 'resource_name', headerName: '자원명', width: 200, headerAlign: 'center', align:'left' },
            { field: 'resource_status', headerName: '자원상태', width: 0, headerAlign: 'center', align:'center' },
            { field: 'resource_status_name', headerName: '자원상태', width: 100, headerAlign: 'center', align:'center' },
            { field: 'resource_type', headerName: '자원유형', width: 0, headerAlign: 'center' },
            { field: 'resource_type_name', headerName: '자원유형', width: 110, headerAlign: 'center', align:'center' },
            { field: 'resource_number', headerName: '자원번호', width: 140, headerAlign: 'center', align:'center' },
            { field: 'resource_desc', headerName: '자원설명', width: 300, headerAlign: 'center', align:'left' },
            { field: 'resource_workplace_id', headerName: '사업장ID', width: 0, headerAlign: 'center', align:'center' },
            { field: 'resource_workplace_name', headerName: '사업장', width: 150, headerAlign: 'center', align:'left' },
            { field: 'resource_location', headerName: '자원위치', width: 130, headerAlign: 'center', align:'left' },
            { field: 'resource_produce_yn', headerName: '생산여부', width: 100, headerAlign: 'center', align:'center' },
            { field: 'resource_login_yn', headerName: 'resource_login_yn', width: 100, headerAlign: 'center', align:'center' },
            { field: 'resource_start_date', headerName: '취득일자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'resource_close_date', headerName: '폐기일자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'resource_currency_price', headerName: '평가금액', width: 140, headerAlign: 'center', align:'right' },
            { field: 'reg_user_name', headerName: '등록자', width: 130, headerAlign: 'center', align:'center' },
            { field: 'update_user_name', headerName: '수정자', width: 130, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        resource_id: false,
        resource_name: true,
        resource_number: true,
        resource_desc: true,
        resource_type: false,
        resource_type_name: true,
        resource_workplace_id: false,
        resource_workplace_name: true,
        resource_location: true,
        resource_produce_yn: false,
        resource_login_yn: false,
        resource_start_date: true,
        resource_close_date: true,
        resource_status: false,
        resource_status_name: true,
        resource_currency_price: true,
        reg_user_name: false,
        update_user_name: false,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView();
        }
    }, [keyword.type, keyword.produce_yn, keyword.status])

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Resource/List',
            {
            params : {
              type: keyword.type,
              produce_yn:keyword.produce_yn,
              status:keyword.status,
              search : keyword.search
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.resource_id]) {
                    PermissionMap[row.resource_id] = [row.reg_user_id, row.update_user_id, row.resource_manager_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            const array = response.data.map((item, index) => ({
                id: item.resource_id,
                resource_id: item.resource_id,
                resource_name: item.resource_name,
                resource_number: item.resource_number,
                resource_desc: item.resource_desc,
                resource_type: item.resource_type,
                resource_type_name: item.resource_type_name,
                resource_workplace_id: item.resource_workplace_id,
                resource_workplace_name: item.resource_workplace_name,
                resource_location: item.resource_location,
                resource_produce_yn: item.resource_produce_yn,
                resource_login_yn: item.resource_login_yn,
                resource_start_date: item.resource_start_date,
                resource_close_date: item.resource_close_date,
                resource_status: item.resource_status,
                resource_status_name: item.resource_status_name,
                resource_currency_price: item.resource_currency_price,
                reg_user_name: item.reg_user_name,
                reg_datetime: (item.reg_datetime === undefined?'':Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_user_name: item.update_user_name,
                update_datetime: (item.update_datetime === undefined?'':Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.resource_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set(array.map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });

    }

    const handleInitSelect = () => {

        //사업장
        axios.get('/api/Common/WorkplaceList')
        .then((response) => {
            var array_modal = response.data.map((item, index) => 
                ({ value: item.workplace_id, label: item.workplace_name })
            );        
            setWorkplaceModalOption(array_modal);
        })
        .catch((error) => {
            console.log(error);
        });

        //담당자
        axios.get('/api/Common/UserList')
        .then((response) => {
            var array_modal = response.data.map((item, index) => 
                ({ value: item.user_id, label: item.user_name})
            );
            setUserModalOption(array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
        
        //자원유형, 자원생산여부, 자원상태
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 

            var type_array = [];
            var type_array_modal = [];
            var price_currency_array_modal = [];
            var user_type_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0021'){
                    type_array.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                    type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0017'){
                    price_currency_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }else if((response.data)[i].code_id === '0020'){
                    user_type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }
            //생산여부
            var produce_array_modal = [
                {value:0, label:'생산여부'}
                ,{value:'Y', label:'Y'}
                ,{value:'N', label:'N'}
            ];
            //자원상태
            var status_array = [
                {value:'1', label:'정상'}
                ,{value:'2', label:'고장'}
                ,{value:'3', label:'수리중'}
                ,{value:'4', label:'분실'}
                ,{value:'5', label:'폐기(미사용)'}
            ];
            // modal 자원상태
            var status_array_modal = [
                {value:'1', label:'정상'}
                ,{value:'2', label:'고장'}
                ,{value:'3', label:'수리중'}
                ,{value:'4', label:'분실'}
                ,{value:'5', label:'폐기(미사용)'}
            ];

            status_array.unshift({ value: 0, label : '자원상태'});
            type_array.unshift({ value: 0, label : '자원유형'});
            price_currency_array_modal.unshift({ value: 0, label : '평가통화단위'});

            setTypeOption(type_array);
            setTypeModalOption(type_array_modal);
            setProduceYnOption(produce_array_modal);
            setStatusOption(status_array);
            setStatusModalOption(status_array_modal);
            setPriceCurrencyModalOption(price_currency_array_modal);
            setUserTypeModalOption(user_type_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleInit = () => {
        setKeyword({
            type: 0,
            produce_yn:0,
            status:0,
            search: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            resource_id: false,
            resource_name: true,
            resource_number: true,
            resource_desc: true,
            resource_type: false,
            resource_type_name: true,
            resource_workplace_id: false,
            resource_workplace_name: true,
            resource_location: true,
            resource_produce_yn: false,
            resource_login_yn: false,
            resource_start_date: true,
            resource_close_date: true,
            resource_status: false,
            resource_status_name: true,
            resource_currency_price: true,
            reg_user_name: false,
            update_user_name: false,
            deleted: true,
            updated: true
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('자원 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('자원 수정');
        setSelectResourceID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '자원 '+object.row.resource_name+' 삭제',
            html : '자원 <span style="color:red; font-weight:bold;">'+object.row.resource_name+'</span>을(를) 삭제 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Resource/Delete', new URLSearchParams({
                    delete_resource_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '자원 '+object.row.resource_name+' 삭제 완료',
                            text: '정상적으로 자원 '+object.row.resource_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false);
                });
                
            }
        });
    };

    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('자원 수정');
        setRegModalOpen(false);
        handleView();

        Swal.fire({
            title: '자원 등록 완료',
            text: '정상적으로 자원이 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectResourceID(Number(regID));

        });
    };

    const handleExcel = () => {
        var filename = '자원관리'
        axios.get('/api/p/Resource/Excel',
        {   
            params : { type: keyword.type, produce_yn:keyword.produce_yn, status:keyword.status, search : keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <ResourceRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        typeModalOption={typeModalOption}
                        statusModalOption={statusModalOption}
                        priceCurrencyModalOption={priceCurrencyModalOption}
                        userTypeModalOption={userTypeModalOption}
                        workplaceModalOption={workplaceModalOption}
                        userModalOption={userModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            자원상태
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="자원상태" onChange={(e) => onSelectChange('status',e.value)} value={statusOption.filter(function (option) { return option.value === keyword.status;  })} options={statusOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title">
                            자원유형
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" placeholder="자원유형" onChange={(e) => onSelectChange('type',e.value)} value={typeOption.filter(function (option) { return option.value === keyword.type;  })} options={typeOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <ResourceUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectResourceID}
                        handleView={handleView}
                        typeModalOption={typeModalOption}
                        statusModalOption={statusModalOption}
                        priceCurrencyModalOption={priceCurrencyModalOption}
                        userTypeModalOption={userTypeModalOption}
                        workplaceModalOption={workplaceModalOption}
                        userModalOption={userModalOption}
                        originRows={originRows.filter(row => String(row.resource_id) === String(selectResourceID))}
                        MenuUpdateYN={MenuUpdateYN}
                        MenuDeleteYN={MenuDeleteYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Resource;
